const actions = {
    FETCH_STORE_PRODUCTS: 'FETCH_STORE_PRODUCTS',
    FETCHING_STORE_PRODUCTS: 'FETCHING_STORE_PRODUCTS',
    FETCHED_STORE_PRODUCTS: 'FETCHED_STORE_PRODUCTS',
    FETCH_STORE_PRODUCTS_FAILED: 'FETCH_STORE_PRODUCTS_FAILED',

    FETCH_STORE_DATA: 'FETCH_STORE_DATA',
    FETCHING_STORE_DATA: 'FETCHING_STORE_DATA',
    FETCHED_STORE_DATA: 'FETCHED_STORE_DATA',
    FETCH_STORE_DATA_FAILED: 'FETCH_STORE_DATA_FAILED',

    ADD_TO_CART: 'ADD_TO_CART',
    ADDED_TO_CART: 'ADDED_TO_CART',
    SUBMIT_TRX: 'SUBMIT_TRX',
    SUBMITTING_TRX: 'SUBMITTING_TRX',
    SUBMITTED_TRX: 'SUBMITTED_TRX',
    SUBMIT_TRX_FAILED: 'SUBMIT_TRX_FAILED',
    SUBMIT_TRX_RESET: 'SUBMIT_TRX_RESET',
  
    fetchStoreProducts: (payload) => ({
        type: actions.FETCH_STORE_PRODUCTS,
        payload: payload,
    }),
    fetchStoreData: (payload) => ({
        type: actions.FETCH_STORE_DATA,
        payload: payload,
    }),
    addToCart: (payload) => ({
        type: actions.ADD_TO_CART,
        payload: payload,
    }),
    checkoutCart: (payload) => ({
        type: actions.SUBMIT_TRX,
        payload: payload,
    }),
    resetCheckout: () => ({
        type: actions.SUBMIT_TRX_RESET,
    }),
};
export default actions;
